import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import { parseDate } from "utils/Utils";
import FindStructureData from "helper/FindStructureType";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";
import { sortByString } from "utils/Utils";

const PacketAllocationCreate = ({
  classes,
  packetAllocationShow,
  packetId,
  setPacketId,
  closeModal,
  dataPacketSize,
  packetAllocationHOShow,
  dataPacketNumberFrom,
  dataPacketNumberTo,
  packetWeight,
  preFix,
}) => {
  const navigate = useNavigate();
  const params = useParams();
  const [packetNumberFrom, setPacketNumberFrom] = useState(
    dataPacketNumberFrom ? dataPacketNumberFrom : ""
  );
  const [packetNumberFromState, setPacketNumberFromState] = useState(false);
  const [packetNumberTo, setPacketNumberTo] = useState(
    dataPacketNumberTo ? dataPacketNumberTo : ""
  );
  const [packetNumberToState, setPacketNumberToState] = useState(false);
  const [packetSize, setPacketSize] = useState(dataPacketSize || "");
  const [packetSizeState, setPacketSizeState] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [callInProgress, setCallInProgress] = useState(false);
  const [structureTypeData, setStructureTypeData]= useState([]);
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [disabledButton, setDisabledButton] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const [branchName, setBranchName] = useState("");
  const [branchNameState, setBranchNameState] = useState("");
  const [packetWeightState, setPacketWeightState]= useState(false);
  const [weight, setPacketWeight]= useState(packetWeight ? packetWeight : "")
  const [preFixName, setPreFixName]= useState(preFix ? preFix : null);
  const [preFixNameState, setPreFixNameState]= useState(false)
  const packetSizes = [
    { code: "3.0*3.0", name: "3.0*3.0" },
    { code: "3.0*6.0", name: "3.0*6.0" },
    { code: "6.0*3.0", name: "6.0*3.0" },
    { code: "6.0*6.0", name: "6.0*6.0" },
    { code: "10.0*6.5", name: "10.0*6.5" },
  ];
  const outletData = useOutletContext();
  const removedPacketSize = outletData?.removePacketSizeFlag
  const packetSizeList = JSON.parse(outletData?.packetSizesList) || packetSizes;
  const enabledPacketPreFix = parseAndSetFlag(outletData?.enabledPacketPreFix);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (branchName === "") {
      setBranchNameState(true);
    } else {
      setBranchNameState(false);
    }
    if (packetSize === "") {
      setPacketSizeState(true);
    } else {
      setPacketSizeState(false);
    }
    if (packetNumberFrom === "") {
      setPacketNumberFromState(true);
    } else {
      setPacketNumberFromState(false);
    }
    if (packetNumberTo === "") {
      setPacketNumberToState(true);
    } else {
      setPacketNumberToState(false);
    }
    if (
      packetNumberFrom === "" ||
      packetNumberTo === "" ||
      branchName === "" ||
      packetSize === ""
    ) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    if(structureTypeData.length){
      getBranchList();
    }
  }, [structureTypeData.length]);

  useEffect(() => {
    if (packetId) {
      GetData();
    }
  }, []);
  useEffect(()=>{
    FindStructureData(apiHandler,endpoint,authToken, setStructureTypeData)
},[])

  const getBranchList = async () => {
    let branchList = [];
    let branchCodes = structureTypeData.filter((b) => b.branchType === true);
    if (branchCodes.length > 0) {
      branchCodes.forEach(async (branch) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_FIND_BY_TYPE_CODE + branch?.code,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const sortedArray = sortByString(result?.data, 'name', true);
      setBranchList(sortedArray);
    }
  })
}
  };

  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PACKET_ALLOCATION_FIND_BY_ID + packetId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setPacketNumberFrom(result?.data?.serialStartNo);
      setPacketNumberTo(result?.data?.serialEndNo);
      setPacketSize(result?.data?.size);
      setBranchName(result?.data?.branchCode.toUpperCase());
      setPacketWeight(result?.data?.packetWeight);
      setPreFixName(result?.data?.prefix || null);
    }
  };
  const handleCreateSubmit = async (event) => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.PACKET_ALLOCATION_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          branchCode: branchName?.toUpperCase(),
          size: packetSize,
          serialStartNo: Number(packetNumberFrom),
          serialEndNo: Number(packetNumberTo),
          packetWeight: parseInt(weight),
          date: parseDate(new Date()),
          prefix: enabledPacketPreFix ? preFixName : null,
        },
      });
      setCallInProgress(false);
       if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        closeModal("create");
        if (packetAllocationHOShow) {
          packetAllocationHOShow(true);
        } else {
          packetAllocationShow(true);
          setPacketId("");
        }
      }
    }
  };

  const handleEditSubmit = async () => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.PACKET_ALLOCATION_UPDATE + packetId,
        method: "PUT",
        authToken: authToken,
        data: {
          branchCode: branchName.toUpperCase(),
          size: packetSize,
          serialStartNo: Number(packetNumberFrom),
          serialEndNo: Number(packetNumberTo),
          date: parseDate(new Date()),
          packetWeight: parseInt(weight),
          prefix: enabledPacketPreFix ? preFixName : null,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        packetAllocationShow(true);
        closeModal("update");
      }
    }
  };

  const handleCancel = () => {
    if (packetAllocationHOShow) {
      packetAllocationHOShow(true);
    } else {
      packetAllocationShow(true);
      setPacketId("");
    }
  };
  const validationCheckCreate = (name) =>{
    if(name === "from" && (Number(packetNumberFrom) < Number(dataPacketNumberFrom) || Number(packetNumberFrom) > Number(dataPacketNumberTo) || Number(packetNumberFrom) > Number(packetNumberTo))){
        toastUpdate("Error", `Packet Number can not be less than ${dataPacketNumberFrom} and greater than ${dataPacketNumberTo}`, true);
        setDisabledButton(true);
        setPacketNumberFrom(dataPacketNumberFrom)
    }
    else if(name === "to" && (Number(packetNumberTo) > Number(dataPacketNumberTo) || Number(packetNumberTo) < Number(packetNumberFrom))){
        toastUpdate("Error", `Packet Number can not be less than ${packetNumberFrom} and greater than ${dataPacketNumberTo}`, true);
        setPacketNumberTo(dataPacketNumberTo)
      }
    else {
      console.log("OK");
      setDisabledButton(false);
    }
  };

  const handlePacketFrom = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex.test(e)) {
      setPacketNumberTo(e);
    }
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={packetId ? "Edit Packet Allocation" : "Packet Allocation"}
          button1=" Save"
          button2=" Cancel"
          disabled1={disabledButton}
          button1click={packetId ? handleEditSubmit : handleCreateSubmit}
          button2click={handleCancel}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Branch Name*"
              error={branchNameState}
              id="branch_channel"
              value={branchName?.toUpperCase()}
              setState={setBranchName}
              data={branchList}
              setError={setBranchNameState}
              type="TYPE"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Packet Size"
              error={packetSizeState}
              value={packetSize}
              setState={setPacketSize}
              data={packetSizeList}
              setError={setPacketSizeState}
              disabled={dataPacketSize}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Packet Number From"
              required
              error={packetNumberFromState}
              id="lp_branch_code"
              value={packetNumberFrom}
              setState={setPacketNumberFrom}
              setError={setPacketNumberFromState}
              setBlur={() => validationCheckCreate("from")}
              disabled={dataPacketNumberFrom}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Packet Number To"
              required
              error={packetNumberToState}
              id="lp_branch_code"
              value={packetNumberTo}
              setError={setPacketNumberToState}
              setState={handlePacketFrom}
              setBlur={() => validationCheckCreate("to")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
               label="Packet Weight"
               required
               error={packetWeightState}
               id="lp_branch_code"
               value={weight || ""}
               setError={setPacketWeightState}
               setState={setPacketWeight}
               disabled={true}
            />
          </Grid>
          {enabledPacketPreFix &&
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                 label="Prefix"
                 required
                 error={preFixNameState}
                 id="lp_branch_code"
                 value={preFixName || ""}
                 setError={setPreFixNameState}
                 setState={setPreFixName}
                 type="prefix"
                 maxLength={4} 
                 disabled={true}
              />
            </Grid>
          }
        </Grid>
      </Grid>
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </Grid>
  );
};

PacketAllocationCreate.propTypes = {
  classes: PropTypes.object,
};

export default PacketAllocationCreate;
